import { render, staticRenderFns } from "./appFormEditItems.vue?vue&type=template&id=2cf3e9f8"
import script from "../../controllers/application_form/app-form-edit-items.js?vue&type=script&lang=js&external"
export * from "../../controllers/application_form/app-form-edit-items.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports